<!--
 * @Description: 服务区车辆 客流 事件统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 11:38:37
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 14:15:14
 -->
<template>
  <div class="serviceAreaCount">
    <div class="item">
      <img src="/static/img/layout/cars.png" alt="">
      <div class="label">车流统计总数</div>
      <div class="value">{{serviceAreaCountData.carFlow}}</div>
    </div>
    <div class="item">
      <img src="/static/img/layout/passenger.png" alt="">
      <div class="label">客流统计总数</div>
      <div class="value">{{serviceAreaCountData.peopleFlow}}</div>
    </div>
    <div class="item">
      <img src="/static/img/layout/AI-event.png" alt="">
      <div class="label">AI识别事件总数</div>
      <div class="value">{{serviceAreaCountData.aiEvent}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceAreaCount',
  components: {
  },
  data () {
    return {
      serviceAreaCountData: {},
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @param   {String}              请求地址
     * @param   {type}                请求标志-区分里程还是时间
     * @return {undefied}             无返回值
     */
    getData (url, type) {
      this.$http.get('/rest/screen/zhfwq/right-top/summary')
        .then(res => {
          if (res.code === 0) {
            this.serviceAreaCountData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .serviceAreaCount {
    width: 100%;
    height: 100%;
    .item {
      width: 100%;
      height: 30%;
      text-align: center;
      color: #fff;
      background: url('/static/img/layout/overviewProductBg.png');
      background-size: 100% 100%;
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      margin: 1% 0;
      img {
        height: 30px;
        padding-left: 15%;
      }
      .label {
        width: 30%;
        font-size: 18px;
      }
      .value {
        width: 30%;
        font-size: 25px;
        font-weight: bold;
      }
    }
  }
</style>
